import { Link } from "react-router-dom";
import { KeyRound, MessageSquare, Phone, ShieldCheck } from "lucide-react";
import { portalHref } from "@/features/portal/portal-base";

/** The three reassurance/action tiles at the foot of the home page. The mockup's
 * "Message your CPA" maps to a phone call (no messaging backend) or the notices
 * surface when no phone is on file. */
export function FooterActions({ phone }: { phone: string }) {
  const tileBase =
    "hover:border-primary hover:shadow-card-hover flex items-center gap-3.5 rounded-xl border-2 bg-card p-5 transition-colors";

  return (
    <section className="grid gap-5 md:grid-cols-3">
      <Link to={portalHref("/password")} className={tileBase}>
        <div className="bg-muted/60 text-muted-foreground grid size-11 shrink-0 place-items-center rounded-sm">
          <KeyRound className="size-5" />
        </div>
        <div>
          <div className="font-semibold text-foreground">Change my password</div>
          <div className="text-muted-foreground text-sm">Keep your account safe</div>
        </div>
      </Link>

      {phone ? (
        <a href={`tel:${phone}`} className={tileBase}>
          <div className="bg-accent text-accent-foreground grid size-11 shrink-0 place-items-center rounded-sm">
            <Phone className="size-5" />
          </div>
          <div>
            <div className="font-semibold text-foreground">Call your tax team</div>
            <div className="text-muted-foreground text-sm">We're happy to help</div>
          </div>
        </a>
      ) : (
        <Link to={portalHref("/notices")} className={tileBase}>
          <div className="bg-accent text-accent-foreground grid size-11 shrink-0 place-items-center rounded-sm">
            <MessageSquare className="size-5" />
          </div>
          <div>
            <div className="font-semibold text-foreground">Your notices</div>
            <div className="text-muted-foreground text-sm">See what your tax team has logged</div>
          </div>
        </Link>
      )}

      <div className="bg-success-soft border-success/20 flex items-center gap-3.5 rounded-xl border-2 p-5">
        <div className="bg-card text-success grid size-11 shrink-0 place-items-center rounded-sm">
          <ShieldCheck className="size-5" />
        </div>
        <div>
          <div className="text-success font-semibold">Your information is private</div>
          <div className="text-success/80 text-sm">Encrypted and only visible to your tax team.</div>
        </div>
      </div>
    </section>
  );
}
